import {Model} from "./Model";

export class Category extends Model {
    course_id;
    slug;
    active;
    name;
    description;
    tier;
    position;
    image;
    topics;
    questions;
    completed;
    topics_completed;
    video_watched;
    selected_topic;
}